var axios = require('axios');
var { SupportSource } = require('./zendeskManager');

const SCIROOT_SUPPORT_PATH = 'support';
export const MAX_SUPPORT_ATTACHMENTS = 5;

/** Authenticated support via Sciroot API → Zendesk agent tickets API. */
export const sendSupportViaApi = async (message, options = {}) => {
  const formData = new FormData();
  formData.append('message', message);
  formData.append('source', options.source || SupportSource.WEB);

  if (options.category) {
    formData.append('category', options.category);
  }

  const files = options.files || [];
  files.slice(0, MAX_SUPPORT_ATTACHMENTS).forEach((file) => {
    formData.append('files', file);
  });

  try {
    const res = await axios.post(SCIROOT_SUPPORT_PATH, formData);
    if (options.returnFullResponse) {
      return res;
    }
    return res.status >= 200 && res.status < 300;
  } catch (err) {
    console.log(
      'Support API error:',
      err?.response?.status,
      err?.response?.data,
    );
    throw err;
  }
};
